import styles from './DocumentSignatures.scss';

import DateTime from 'common/components/DateTime/DateTime';
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';

const DocumentSignatures = ({ signatures }) => {
    return (
        <section className={styles.documentSignaturesContainer}>
            <header className={styles.header}>Document Signatures</header>
            {signatures.map(signature => {
                const key = signature.user.sub+signature.dateSigned;

                return (
                    <div className={styles.signatureRecord} key={key} data-cy={'DocumentProgress-' + key}>
                        <span className={styles.signatureUser} data-cy={'DocumentProgress-name-' + key}>
                            {signature.user.name}
                        </span>
                        <div className={styles.signatureDate}>
                            <DateTime value={signature.dateSigned} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} time={true} />
                        </div>
                        <span className={styles.signatureStatement} data-cy={'DocumentProgress-statement-' + key}>
                            {signature.statement.statement}
                        </span>
                    </div>
                );
            })}
        </section>
    );
};

export default DocumentSignatures;
